export default "__VITE_ASSET__DC6kj_X9__"